var SchemaTriggerIntervalValueType = {
    NONE: 0,
    OPERATIONAL_HOURS: 1,
    // TIMEINTERVAL_SECONDS: 2,
    TIMEINTERVAL_WEEKS: 3,
    TIMEINTERVAL_MONTHS: 4,
    TIMEINTERVAL_YEARS: 5,
    TIMEINTERVAL_DAYS: 6,
    isPeriodial: function (value) {
        return value !== SchemaTriggerIntervalValueType.NONE &&
            value !== SchemaTriggerIntervalValueType.OPERATIONAL_HOURS;
    },
    getKeyByValue: function (value) {
        var _this = this;
        return Object.keys(this).find(function (key) {
            return _this[key] === value;
        });
    }
};
export default SchemaTriggerIntervalValueType;
